import { lazy } from "react"

/**
 * Helper function to create lazy-loaded components from named exports.
 * This simplifies the syntax for lazy loading components that use named exports
 * instead of default exports.
 *
 * @param importFn - A function that returns a promise importing the module
 * @param exportName - The name of the named export to use as the default
 * @returns A lazy-loaded React component
 *
 * @example
 * ```tsx
 * const LazyComponent = lazyNamed(
 *   () => import("./MyComponent"),
 *   "MyComponent"
 * )
 * ```
 */
export const lazyNamed = (importFn: () => Promise<any>, exportName: string) =>
  lazy(() => importFn().then((module) => ({ default: module[exportName] })))
